import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Panel Options", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "The contents of this popover menu are coming soon", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LayoutRow = _resolveComponent("LayoutRow")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_IconLabel = _resolveComponent("IconLabel")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_UserInputLabel = _resolveComponent("UserInputLabel")!
  const _component_LayoutCol = _resolveComponent("LayoutCol")!

  return (_openBlock(), _createBlock(_component_LayoutCol, { class: "panel" }, {
    default: _withCtx(() => [
      _createVNode(_component_LayoutRow, {
        class: _normalizeClass(["tab-bar", { 'min-widths': _ctx.tabMinWidths }]),
        "data-tab-bar": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LayoutRow, {
            class: "tab-group",
            scrollableX: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabLabels, (tabLabel, tabIndex) => {
                return (_openBlock(), _createBlock(_component_LayoutRow, {
                  class: _normalizeClass(["tab", { active: tabIndex === _ctx.tabActiveIndex }]),
                  "data-tab": "",
                  key: tabIndex,
                  onClick: (e) => (e?.stopPropagation(), _ctx.clickAction?.(tabIndex)),
                  onMouseup: _withModifiers((e) => (e?.stopPropagation(), _ctx.closeAction?.(tabIndex)), ["middle"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(tabLabel), 1),
                    (_ctx.tabCloseButtons)
                      ? (_openBlock(), _createBlock(_component_IconButton, {
                          key: 0,
                          action: (e) => (e?.stopPropagation(), _ctx.closeAction?.(tabIndex)),
                          icon: 'CloseX',
                          size: 16
                        }, null, 8, ["action"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick", "onMouseup"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_PopoverButton, { icon: 'VerticalEllipsis' }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_LayoutCol, { class: "panel-body" }, {
        default: _withCtx(() => [
          (_ctx.panelType)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.panelType), { key: 0 }))
            : (_openBlock(), _createBlock(_component_LayoutCol, {
                key: 1,
                class: "empty-panel"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LayoutCol, { class: "content" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LayoutRow, { class: "logotype" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconLabel, { icon: 'GraphiteLogotypeSolid' })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_LayoutRow, { class: "actions" }, {
                        default: _withCtx(() => [
                          _createElementVNode("table", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_TextButton, {
                                  label: 'New Document:',
                                  icon: 'File',
                                  action: () => _ctx.newDocument()
                                }, null, 8, ["action"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_UserInputLabel, {
                                  keysWithLabelsGroups: [[..._ctx.platformModifiers(true), { key: 'KeyN', label: 'N' }]]
                                }, null, 8, ["keysWithLabelsGroups"])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_TextButton, {
                                  label: 'Open Document:',
                                  icon: 'Folder',
                                  action: () => _ctx.openDocument()
                                }, null, 8, ["action"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_UserInputLabel, {
                                  keysWithLabelsGroups: [[..._ctx.platformModifiers(false), { key: 'KeyO', label: 'O' }]]
                                }, null, 8, ["keysWithLabelsGroups"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}